export const CF7_RECAPTCHA_SITE_KEY = '6LfpEwgtAAAAAK-pkiUuhPtFNL6LfgDESwpam-vz';

const CF7_RECAPTCHA_ACTION = 'contactform';
const CF7_RECAPTCHA_RESPONSE_FIELD = '_wpcf7_recaptcha_response';

let recaptchaScriptPromise = null;

const isBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';

const loadRecaptchaScript = () => {
  if (!isBrowser() || !CF7_RECAPTCHA_SITE_KEY) {
    return Promise.resolve(null);
  }

  if (window.grecaptcha?.ready) {
    return Promise.resolve(window.grecaptcha);
  }

  if (recaptchaScriptPromise) {
    return recaptchaScriptPromise;
  }

  recaptchaScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector('script[data-cf7-recaptcha="true"]');

    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.grecaptcha), {once: true});
      existingScript.addEventListener('error', reject, {once: true});
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.dataset.cf7Recaptcha = 'true';
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(CF7_RECAPTCHA_SITE_KEY)}`;
    script.onload = () => resolve(window.grecaptcha);
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA script'));

    document.head.appendChild(script);
  });

  return recaptchaScriptPromise;
};

export const getCf7RecaptchaToken = async () => {
  if (!isBrowser() || !CF7_RECAPTCHA_SITE_KEY) {
    return '';
  }

  const grecaptcha = await loadRecaptchaScript();

  if (!grecaptcha?.ready) {
    return '';
  }

  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      const readyRecaptcha = window.grecaptcha;

      if (!readyRecaptcha?.execute) {
        resolve('');
        return;
      }

      readyRecaptcha
        .execute(CF7_RECAPTCHA_SITE_KEY, {action: CF7_RECAPTCHA_ACTION})
        .then(resolve)
        .catch(reject);
    });
  });
};

export const appendCf7RecaptchaToken = async (formData) => {
  const token = await getCf7RecaptchaToken();

  if (token) {
    formData.set(CF7_RECAPTCHA_RESPONSE_FIELD, token);
  }

  return formData;
};
